import { Pipe, PipeTransform } from '@angular/core'
import { formatDateFromBack } from '../utils/utils'

@Pipe({
    name: 'formatDateFromBack',
    standalone: true,
})
export class FormatDateFromBack implements PipeTransform {
    transform(dateString: string): string {
        return formatDateFromBack(dateString)
    }
}
